import moment from 'moment';

/**
 * Format de date dans la collection ByDateCollection
 */
export const BY_DAY_COLLECTION_FORMAT = 'YYYY-MM-DD';

/**
 * Collection d'objet par jour
 */
export class ByDayCollection<T> {
  private readonly values: { [date: string]: T };

  constructor(valByDate: { [date: string]: T } | ByDayCollection<T> = null) {
    // Populate collection
    this.values = Object.create(null);
    if (valByDate instanceof ByDayCollection) {
      this.values = { ...valByDate.values };
    } else if (valByDate) {
      if (valByDate['values']) {
        valByDate = <any>valByDate['values'];
      }
      Object.keys(valByDate).forEach((k) => (this.values[moment(k).format(BY_DAY_COLLECTION_FORMAT)] = valByDate[k]));
    }
  }

  public get size(): number {
    return Object.keys(this.values).length;
  }

  public get(date: moment.MomentInput): T {
    if (!date) {
      return undefined;
    }
    return this.values[this.formatDate(date)];
  }

  public put(date: moment.MomentInput, value: T) {
    if (!date) {
      throw new ByDayCollectionDateNotFoundException();
    }
    this.values[this.formatDate(date)] = value;
  }

  public delete(date: moment.MomentInput) {
    if (!date) {
      throw new ByDayCollectionDateNotFoundException();
    }
    delete this.values[this.formatDate(date)];
  }

  public has(date: moment.MomentInput): boolean {
    if (!date) {
      return false;
    }
    return !!(this.formatDate(date) in this.values);
  }

  /**
   * Retourne les valeurs de la collection sous forme de tableau
   */
  public getValues(): T[] {
    return Object.keys(this.values).map((key) => this.values[key]);
  }

  /**
   * Get all stored dates sorted
   */
  public dates(): Date[] {
    return Object.keys(this.values)
      .sort()
      .map((k) => moment(k, BY_DAY_COLLECTION_FORMAT).toDate());
  }

  /**
   * Get min date of collection
   */
  public minDate(): Date {
    return this.dates()[0];
  }

  /**
   * Get max date of collection
   */
  public maxDate(): Date {
    const dates = this.dates();
    return dates[dates.length - 1];
  }

  private formatDate(date: moment.MomentInput): string {
    return moment(date).format(BY_DAY_COLLECTION_FORMAT);
  }
}

export class ByDayCollectionDateNotFoundException extends Error {
  constructor() {
    super('Date could not be null');
  }
}
